import { AnomalyUI } from '@shared';
import { Dispatch, useEffect, useReducer } from 'react';
import { Actions, ActionsType } from '../Audit.types';

export function useVisibleAnomalies(
  anomalies: AnomalyUI[] | undefined
): [AnomalyUI[], Dispatch<ActionsType>] {
  function reducer(state: AnomalyUI[], action: ActionsType) {
    const { type, payload } = action;
    switch (type) {
      case Actions.ANOMALIESREADY:
        return payload;
      case Actions.HIDE:
        return state
          .filter((anomaly) => anomaly.type !== payload)
          .sort((a, b) => a.start - b.start);
      case Actions.SHOW:
        return state
          .concat(anomalies?.filter((anomaly) => anomaly.type === payload) || [])
          .sort((a, b) => a.start - b.start);
      default:
        throw new Error('Wrong action in toggle anomalies reducer');
    }
  }
  const [visibleAnomalies, dispatch] = useReducer(reducer, []);

  useEffect(() => {
    anomalies && dispatch({ type: Actions.ANOMALIESREADY, payload: anomalies });
  }, [anomalies]);
  return [visibleAnomalies, dispatch];
}
